export default __webpack_public_path__ + "static/media/logo.cfb58bc9.png";